import type { z } from 'zod';

import { pickTicketsItemQuerySchema } from './pick-ticket-item-query-schema';

export const pickTicketsItemFormSchema = pickTicketsItemQuerySchema.refine((data) => !!data.inventory, {
  path: ['inventory'],
  message: 'Inventory is required',
});

export type PickTicketsItemFormSchema = z.infer<typeof pickTicketsItemFormSchema>;
